import { isConciergeCheckoutRenderable, type CheckoutSnapshot } from "./concierge-parsers";

type ConciergeCheckoutViewOptions = {
  card: HTMLElement | null;
  checkout?: CheckoutSnapshot;
  paymentStatusRefreshing: boolean;
  activeRequestId?: string;
  paymentStatusMessage?: string;
  lastPaymentStatusCheckAt?: number;
  locale: string;
  paymentIsFinished: (checkout: CheckoutSnapshot) => boolean;
  paymentStatusLabel: (status: string | undefined) => string;
  onRefresh: () => void;
};

export function renderConciergeCheckout({
  card,
  checkout,
  paymentStatusRefreshing,
  activeRequestId,
  paymentStatusMessage,
  lastPaymentStatusCheckAt,
  locale,
  paymentIsFinished,
  paymentStatusLabel,
  onRefresh
}: ConciergeCheckoutViewOptions): void {
  if (!card) return;
  if (!checkout || !isConciergeCheckoutRenderable(checkout)) {
    card.hidden = true;
    card.replaceChildren();
    card.classList.remove("failed");
    return;
  }
  card.hidden = false;
  card.classList.toggle("failed", ["failed", "cancelled", "expired"].includes(checkout.status ?? ""));
  card.setAttribute("aria-busy", paymentStatusRefreshing ? "true" : "false");
  card.replaceChildren();
  const strong = document.createElement("strong");
  const confirmed = checkout.bookingStatus === "confirmed" || checkout.eventOrderStatus === "confirmed" || checkout.recurringPaymentState === "paid";
  strong.textContent = confirmed ? "Reserva confirmada" : checkout.status === "paid" ? "Pago aprobado" : "Checkout seguro";
  const small = document.createElement("small");
  small.textContent = confirmed ? "La reserva quedó confirmada en Kuroo." : paymentStatusLabel(checkout.status);
  card.append(strong, small);
  if (checkout.statusDetail) {
    const detail = document.createElement("small");
    detail.textContent = `Detalle del proveedor: ${checkout.statusDetail}`;
    card.append(detail);
  }
  if (checkout.checkoutUrl) {
    const link = document.createElement("a");
    link.href = checkout.checkoutUrl;
    link.target = "_blank";
    link.rel = "noreferrer noopener";
    link.textContent = "Pagar ahora en checkout seguro";
    card.append(link);
  }
  if (checkout.paymentId && !paymentIsFinished(checkout)) {
    const button = document.createElement("button");
    button.type = "button";
    button.textContent = paymentStatusRefreshing ? "Consultando…" : "Consultar estado ahora";
    button.disabled = Boolean(activeRequestId) || paymentStatusRefreshing;
    button.setAttribute("aria-busy", paymentStatusRefreshing ? "true" : "false");
    button.addEventListener("click", onRefresh);
    card.append(button);
  }
  if (paymentStatusMessage) {
    const refresh = document.createElement("small");
    refresh.className = "payment-refresh-status";
    refresh.textContent = paymentStatusMessage;
    card.append(refresh);
  }
  if (lastPaymentStatusCheckAt) {
    const checked = document.createElement("small");
    checked.className = "payment-refresh-status";
    checked.textContent = `Última consulta: ${new Date(lastPaymentStatusCheckAt).toLocaleTimeString(locale)}`;
    card.append(checked);
  }
}
